import { Stack, TextField } from '@mui/material';
import { DialogConfirm } from 'app/components/elements/DialogConfirm';
import { InputSelect } from 'app/components/elements/InputSelect';
import { useMemo } from 'react';
import type { IssuesUiConfig } from 'utils/issueDueDateColor';

type UserOption = { value: string | number; label: string };

export const IssueNotifyModal = ({
  isOpen,
  onClose,
  onSubmit,
  disabled,
  issuesConfig,
  userOptions,
  selectedUserIds,
  onSelectedUserIdsChange,
  selectedChannels,
  onSelectedChannelsChange,
  message,
  onMessageChange
}: {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void | Promise<void>;
  disabled?: boolean;
  issuesConfig: IssuesUiConfig;
  userOptions: UserOption[];
  selectedUserIds: number[];
  onSelectedUserIdsChange: (ids: number[]) => void;
  selectedChannels: string[];
  onSelectedChannelsChange: (channels: string[]) => void;
  message: string;
  onMessageChange: (value: string) => void;
}) => {
  const channelOptions = useMemo(() => {
    const opts: { label: string; value: string }[] = [];
    if (issuesConfig.notifyChannelPush) {
      opts.push({ label: 'Push Notification', value: 'pushnotification' });
    }
    if (issuesConfig.notifyChannelEmail) {
      opts.push({ label: 'Email', value: 'email' });
    }
    if (issuesConfig.notifyChannelSms) {
      opts.push({ label: 'SMS', value: 'sms' });
    }
    return opts;
  }, [issuesConfig]);

  return (
    <DialogConfirm
      isOpen={isOpen}
      onClose={onClose}
      textTitle="Send Manual Notification"
      textButton={disabled ? 'Sending...' : 'Send Notification'}
      textCancel="Cancel"
      onSubmit={onSubmit}
      isIconClose
      maxWidth={500}
      disabled={disabled}>
      <Stack gap={2} width="100%">
        <InputSelect
          multiple
          title="Notify Users"
          placeholder="Select users to notify"
          value={selectedUserIds.map(String)}
          onChange={(e) => onSelectedUserIdsChange((e.target.value as string[]).map(Number))}
          options={userOptions.map((u) => ({ label: u.label, value: String(u.value) }))}
          sx={{ width: '100%' }}
        />
        <InputSelect
          multiple
          title="Notification Channels"
          placeholder={
            channelOptions.length ? 'Select channels' : 'No channels enabled in Issues config'
          }
          value={selectedChannels}
          onChange={(e) => onSelectedChannelsChange(e.target.value as string[])}
          options={channelOptions}
          sx={{ width: '100%' }}
          disabled={!channelOptions.length}
        />
        <TextField
          label="Custom Message (Optional)"
          placeholder="Enter custom message or leave blank for default"
          value={message}
          onChange={(e) => onMessageChange(e.target.value)}
          multiline
          minRows={2}
          sx={{ width: '100%' }}
        />
      </Stack>
    </DialogConfirm>
  );
};
